module.exports = __webpack_public_path__ + "img/services-1.3468fc79.jpg";